export const LOCATIONS_TABLE_HEADERS = ["ID", "Location Name", "Address"];

export const MANAGER_CLIENTS_LOCATIONS_BREADCRUMBS = [
  { id: "/", name: "Home" },
  { id: "/washroomlogs", name: "Clients" },
  { id: "/washroomlogs/:id", name: ":id" },
];

export const CLIENTS_LOCATIONS_BREADCRUMBS = [
  { id: "/washroomlogs", name: "Home" },
  { id: "/washroomlogs?user=client", name: ":id" },
];

export const DEFAULT_PAGE_SIZE = 10;
export const INITIAL_LAST_PAGE = 1000000000;

export type LocationParams = {
  user?: string;
};
